import casinoConfig from '@dcentralexpedientedigital/config';

const REQUIRED_ACTION_HASH = '#required-action=';

let requiredAction: false | string = false;

export function checkRequiredAction() {
    if (location.hash.startsWith(REQUIRED_ACTION_HASH)) {
        requiredAction = location.hash.slice(REQUIRED_ACTION_HASH.length);
        console.log('Required action', requiredAction);
        location.hash = '';
        return true;
    }

    return false;
}

export function getRequiredAction() {
    if (requiredAction) {
        try {
            const url = new URL(requiredAction);

            if (!requiredAction.startsWith(casinoConfig.authConfig.authority)) {
                console.log(
                    'Required action origin is not the same as the auth config authority',
                    url.origin,
                    casinoConfig.authConfig.authority,
                );
                return false;
            }

            return url.toString();
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    return false;
}
